//Vanila JS plugin boilerplate
//ref; https://github.com/ccurtin/vanilla-js-plugin-boilerplate/blob/basic-template/index.js
(function (root, factory) {
  var pluginName = 'ChosenCustom';

  if (typeof define === 'function' && define.amd) {
    define([], factory(pluginName));
  } else if (typeof exports === 'object') {
    module.exports = factory(pluginName);
  } else {
    root[pluginName] = factory(pluginName);
  }
})(this, function (pluginName) {

  var defaults = {
    selector: document.querySelector('.bstack-chosen-container'),
    cssClass: [],
    ID: "Chosen" + bsLib.uniqueID(),
    placeholder: "Please choose option",
    multiple: false,
    search: false,
    searchPlaceholder: "Search...",
    reset: false
  };

  /**
   * Merge defaults with user options
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   */
  var extend = function( target, options ) {
      var prop, extended = {};
      for ( prop in defaults ) {
          if ( Object.prototype.hasOwnProperty.call( defaults, prop ) ) {
              extended[ prop ] = defaults[ prop ];
          }
      }
      for ( prop in options ) {
          if ( Object.prototype.hasOwnProperty.call( options, prop ) ) {
              extended[ prop ] = options[ prop ];
          }
      }
      return extended;
  };

  /**
   * Helper Functions
   @private
   */
  var uiBindings = function(that) {
    var liElement, optionValue, optionText, select = that.select;

    select.style.display = "none";
    select.dataset.id = that.options.ID;

    wrapElement(that);

    if (that.options.search) {
      liElement = document.createElement("li");

      var searchElement = document.createElement("input");
      liElement.classList.add("select-dropdown__search-li");
      searchElement.type = "text";
      searchElement.classList.add("select-dropdown__search-li-input");
      searchElement.placeholder = that.options.searchPlaceholder;
      searchElement.autocomplete = "off";
      searchElement.tabIndex = -1;
      searchElement.id = "searchField"+ that.options.ID;
      liElement.appendChild(searchElement);

      that.ulElement.appendChild(liElement);

      liElement = document.createElement("li");
      liElement.classList.add("select-dropdown__no-search-results");
      liElement.classList.add("vwo-hide");
      that.ulElement.appendChild(liElement);

      searchElement.addEventListener(
        "keyup",
        function() {
          var val = this.value.trim(),
          noResultFound = val.length > 0 ? true : false,
          selLi = that.ulElement.querySelectorAll("li"),
          noResultli = that.ulElement.querySelector("li.select-dropdown__no-search-results");

          for (var index = 0; index < selLi.length; index++) {
            if (val.length == 0) {
              selLi[index].classList.remove("vwo-hide");
            } else if (selLi[index].classList.contains("select-dropdown__list-item")) {
              if (selLi[index].dataset.value.length > 0) {
                if (selLi[index].dataset.value.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
                  selLi[index].classList.remove("vwo-hide");
                  noResultFound = false;
                } else {
                  selLi[index].classList.add("vwo-hide");
                }
              }
            }
          }

          //show no search results
          if (noResultFound) {
            noResultli.classList.remove("vwo-hide");
            noResultli.innerHTML = 'No results match <span>'+ val +'</span>';
          } else {
            noResultli.classList.add("vwo-hide");
          }
        },
        false
      );
    }

    for (var index = 0; index < select.options.length; index++) {
      if (select.options[index].value) {
        liElement = document.createElement("li");
        optionValue = select.options[index].value;
        optionText = document.createTextNode(select.options[index].text);
        liElement.className = "select-dropdown__list-item";
        liElement.setAttribute("data-value", optionValue);

        if (that.options.multiple) {
          var checkbox = document.createElement('input');
              
          // Assigning the attributes
          checkbox.type = "checkbox";
          checkbox.name = that.options.ID + "name[]";
          checkbox.value = select.options[index].text;
          checkbox.className = "select-dropdown__list-checkbox";
          checkbox.id =  that.options.ID + "-checkbox-i-" + index;

          // creating label for checkbox
          var optionText = document.createElement('label');
            
          // assigning attributes for 
          // the created label tag 
          optionText.htmlFor = checkbox.id;
          optionText.className = "select-dropdown__list-label";
            
          // appending the created text to 
          // the created label tag 
          optionText.appendChild(document.createTextNode(select.options[index].text));
            
          // appending the checkbox
          // and label to div
          liElement.appendChild(checkbox);

          checkbox.addEventListener(
            "change",
            function(event) {
              displyMultiUI(event, this, that);
            },
            false
          );
        }

        liElement.appendChild(optionText);
        that.ulElement.appendChild(liElement);

        if (!that.options.multiple) {
          liElement.addEventListener(
            "click",
            function() {
              displyUI(this, that);
            },
            false
          );
        }
      }
    }

    if (that.options.multiple) {
      var clearSelect = select.parentNode.querySelectorAll(
        ".select-dropdown__button-clear"
      );

      for (var i = 0; i < clearSelect.length; i++) {
        clearSelect[i].addEventListener(
          "click",
          function() {
            resetFunc(that);
          },
          false
        );
      }
    }

    //Button Dropdown Select
    var buttonSelect = select.parentNode.querySelectorAll(
      ".select-dropdown__button, .select-dropdown__arrow"
    );
    for (var i = 0; i < buttonSelect.length; i++) {
      buttonSelect[i].addEventListener(
        "click",
        function() {
          displyUI(this, that);
        },
        false
      );
    }
    
    //Set Default OnLoad Value
    if (select.value) {
      selectElement(select.value, that);
      var elementParentSpan = select.parentNode.querySelector(
        ".select-dropdown__button-span"
      );
      elementParentSpan.textContent = select.options[select.selectedIndex].text;
      elementParentSpan.parentNode.setAttribute("data-value", select.value);
    }

    /*
     * When the user clicks anywhere outside of the modal, close it
     */
    window.addEventListener(
      "click",
      function(event) {
        if (!event.target.closest(".select-dropdown--" + that.options.ID )) {
          var selectList = document.querySelectorAll(".select-dropdown__list--" + that.options.ID );
          for (var index = 0; index < selectList.length; index++) {
            selectList[index].classList.remove("active");
          }
        }
      },
      false
    );

    //closest Polyfill
    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i,
          el = this;
        do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) {}
        } while (i < 0 && (el = el.parentElement));
        return el;
      };
    }
  };

  function displyUI(element, that) {
    var elementParentSpan, selectDropdown, select = that.select;
    if (element.tagName === "BUTTON" || element.tagName === "DIV") {
      selectDropdown = element.parentNode.getElementsByTagName("ul");
      for (var i = 0; i < selectDropdown.length; i++) {
        selectDropdown[i].classList.toggle("active");
      }
    } else if (element.tagName == "LI") {
      selectElement(element.getAttribute("data-value"), that);
      element.parentNode.classList.toggle("active");

      elementParentSpan = select.parentNode.querySelector(
        ".select-dropdown__button-span"
      );
      elementParentSpan.textContent = element.textContent;
      elementParentSpan.parentNode.setAttribute(
        "data-value",
        element.getAttribute("data-value")
      );

      //dispatchEvent Change
      select.dispatchEvent(createNewEvent("change"));
    }
  }

  function displyMultiUI(event, element, that) {
    var select = that.select;
    if (event.currentTarget.checked) {
      that.choose.push(element.value);
    } else {
      that.choose = that.choose.filter(function(e) { return e !== element.value });
    }

    selectElement(element.value, that);

    var elementParentSpan = select.parentNode.querySelector(".select-dropdown__button-span"),
    elementClearSpan = select.parentNode.querySelector(".select-dropdown__button-clear");
    
    if (that.choose.length > 0) {
      var textCont = "";
      for (var index = that.choose.length - 1; index >= 0; index--) {
        textCont += that.choose[index] + (0 == index ? "": ", ");
      }
      elementParentSpan.textContent = textCont;
      elementParentSpan.title = textCont;

      elementClearSpan.classList.add("active");
    } else {
      elementParentSpan.textContent = select.dataset.placeholder;
      elementParentSpan.title = select.dataset.placeholder;
      elementClearSpan.classList.remove("active");
    }

    //dispatchEvent Change
    select.dispatchEvent(createNewEvent("change"));
  }

  function selectElement(valueToSelect, that) {
    var select = that.select;

    if (that.options.multiple) {
      for (var j = 0; j < select.options.length; j++) {
        if (that.choose.indexOf(select.options[j].value) !== -1) {
          select.options[j].setAttribute("selected", "selected");
        } else {
          select.options[j].removeAttribute("selected");
        }
      }
    } else {
      select.value = valueToSelect;

      for (var j = 0; j < select.options.length; j++) {
        if (select.options[j].value === valueToSelect) {
          select.selectedIndex = j;
          select.options[j].setAttribute("selected", "selected");
        } else {
          select.options[j].removeAttribute("selected");
        }
      }
    }
  }

  function createNewEvent(eventName) {
    var event;
    if (typeof Event === "function") {
      event = new Event(eventName);
    } else {
      event = document.createEvent("Event");
      event.initEvent(eventName, true, true);
    }
    return event;
  }

  

  function wrapElement(that) {
    var wrapper = document.createElement("div"),
      buttonElement = document.createElement("button"),
      spanElement = document.createElement("span"),
      spanText = document.createTextNode("Select Items"),
      selectArrow = document.createElement("div"),
      select = that.select;

    that.ulElement = document.createElement("ul");
    
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    wrapper.className = "select-dropdown select-dropdown--" + that.options.ID + " " + (that.options.multiple ? "select-multiple" : "");
    buttonElement.className =
      "select-dropdown__button select-dropdown__button--" + that.options.ID;
    buttonElement.setAttribute("data-value", "");
    buttonElement.setAttribute("type", "button");
    spanElement.className =
      "select-dropdown select-dropdown__button-span select-dropdown--" +
      that.options.ID;
    if (that.options.placeholder && !select.value) {
      spanText = document.createTextNode(that.options.placeholder);
    }
    that.ulElement.className = "select-dropdown__list select-dropdown__list--" + that.options.ID + " " + (that.options.multiple ? "select-multiple" : "");
    that.ulElement.id = "select-dropdown__list-" + that.options.ID;
    that.ulElement.tabIndex = -1;
    selectArrow.className = "select-arrow select-dropdown__arrow";

    selectArrow.innerHTML = '<span class="select-dropdown__arrow-vector"><svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.5L5 5.5L10 0.5H0Z" fill="#666666"/></svg></span>';

    if (that.options.multiple) {
      var clearElement = document.createElement("span");
      clearElement.className ="select-dropdown select-dropdown__button-clear select-dropdown--" + that.options.ID;
      clearElement.title = "Clear selected option";
      clearElement.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00016 0.333374C3.3135 0.333374 0.333496 3.31337 0.333496 7.00004C0.333496 10.6867 3.3135 13.6667 7.00016 13.6667C10.6868 13.6667 13.6668 10.6867 13.6668 7.00004C13.6668 3.31337 10.6868 0.333374 7.00016 0.333374ZM10.3335 9.39337L9.3935 10.3334L7.00016 7.94004L4.60683 10.3334L3.66683 9.39337L6.06016 7.00004L3.66683 4.60671L4.60683 3.66671L7.00016 6.06004L9.3935 3.66671L10.3335 4.60671L7.94016 7.00004L10.3335 9.39337Z" fill="#787878"/></svg>';

      selectArrow.appendChild(clearElement);
    }

    wrapper.appendChild(buttonElement);
    spanElement.appendChild(spanText);
    buttonElement.appendChild(spanElement);
    wrapper.appendChild(that.ulElement);
    wrapper.appendChild(selectArrow);
  }

  function resetFunc(that) {
    //set select
    that.select = that.options.selector;

    if (!that.select) {
      return;
    }

    that.select.selectedIndex = -1;

    var elementParentSpan = that.select.parentNode.querySelector(
      ".select-dropdown__button-span"
    );

    elementParentSpan.textContent = that.select.dataset.placeholder;
    elementParentSpan.title = that.select.dataset.placeholder;
    elementParentSpan.parentNode.setAttribute("data-value", "");

    that.choose = [];

    for (var j = 0; j < that.select.options.length; j++) {
      that.select.options[j].removeAttribute("selected");
    }

    if (that.options.multiple) {
      var checkboxes = document.querySelectorAll('input[name="'+ that.options.ID +'name[]"]'),
      elementClearSpan = that.select.parentNode.querySelector(".select-dropdown__button-clear");

      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = false;
      }

      //reset class for clear btn
      elementClearSpan.classList.remove("active");
    }
  }

  /**
   * Plugin Object
   * @param {Object} options User options
   * @constructor
   */
  function Plugin(options) {
    var that = this;
    that.options = extend(defaults, options);

    that.choose = [];
    
    if (that.options.reset) {
      that.options.ID = that.options.selector.dataset.id;
      that.reset();
    } else {
      that.init(); // Initialization Code Here
    }
  }

  /**
   * Plugin prototype
   * @public
   * @constructor
   */
  Plugin.prototype = {
      init: function() {
        var t = this;

        //set select
        t.select = t.options.selector;

        if (!t.select) {
          return;
        }

        uiBindings(t);
      }, // #! init
      reset: function () {
        resetFunc(this);
      }
  };
  return Plugin;
});

